class FastshopResume {
    constructor() {
      this.currentProducts = [];
      this.currentDiscount = 0;
    }

    setCurrentDiscount(discount){
      this.currentDiscount = discount;
    }

    getCurrentDiscount(){
      return this.currentDiscount;
    }

    addProduct(product) {
      this.currentProducts.push(product);
      this.verifyUpsellRule(product);
    }
    removeProduct(product) {
      const currentProductIndex = this.currentProducts.findIndex(p => p.id === product.id);
      if (currentProductIndex !== -1) {
          this.currentProducts.splice(currentProductIndex, 1);
      }
      this.verifyUpsellRule(product);
    }

    getCurrentProductList(){
      return this.currentProducts;
    }

    verifyUpsellRule(){
        const hasUpsellProduct = this.currentProducts.some(product => !product.handle.includes('supercoffee'));
        const upsellElement = document.querySelector('.upsell-trigger-button');
        const successIcon = document.querySelector('.success-icon-upsell');
        if(successIcon != null && upsellElement != null){
          if(hasUpsellProduct){
            successIcon?.classList.remove('hidden');
            upsellElement?.classList.add('hidden');
          }else{
            successIcon?.classList.add('hidden');
            upsellElement?.classList.remove('hidden');
          }
        }
      }
  }
  const fastshopResume = new FastshopResume();
  function updateFastshopResume(product, type){
    switch(type){
      case 'plus':
      fastshopResume.addProduct(product);
      break;
      case 'minus':
      fastshopResume.removeProduct(product);
      break;
    }
  }

  function clearFastshopResume(){
    fastshopResume.currentProducts =  [];
  }